module.exports = __webpack_public_path__ + "static/media/top-active-players-active-light-icon.e58fe654.svg";